import NavLink, { NavLinkProps } from './navLink';

export type { NavLinkProps };
export default NavLink;
